import React from 'react';

import { Grid } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

import grandmaAndLady from '../assets/grandmaAndLady.jpg';
import grandmaAndLadyM from '../assets/grandmaAndLadyM.jpg';
import grandmaAndLady2 from '../assets/grandmaAndLady2.jpg';
import grandmaAndLady3 from '../assets/grandmaAndLady3.jpg';
import grandmaAndLady4 from '../assets/grandmAndLady4.jpg';
import cookies from '../assets/cookies.jpg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    marginTop: '6.5rem',
    [theme.breakpoints.down('sm')]: {
      marginTop: '2.5rem'
    }
  },
  row1: {
    width: '100%'
  },
  halfPhoto: {
    width: '50%'
  }
}));

const PhotoCollage3 = () => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesSM = useMediaQuery(theme.breakpoints.down('sm'));
  const { ref, inView } = useInView({ triggerOnce: true });

  const renderer = (
    <Grid container direction="column" className={classes.imgCont}>
      <Grid container className={classes.row1}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 0.4 } }}
          src={matchesSM ? grandmaAndLadyM : grandmaAndLady}
          alt="grandma on phone"
          style={{ width: '100%' }}
        />
      </Grid>
      <Grid container className={classes.row1}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 1 } }}
          src={grandmaAndLady2}
          alt="grandma and lady"
          className={classes.halfPhoto}
        />
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 1.6 } }}
          src={cookies}
          alt="plate of cookies"
          className={classes.halfPhoto}
        />
      </Grid>
      <Grid container className={classes.row1}>
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 2.2 } }}
          src={grandmaAndLady3}
          alt="grandma and lady"
          className={classes.halfPhoto}
        />
        <motion.img
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 2, delay: 2.8 } }}
          src={grandmaAndLady4}
          alt="plate of cookies"
          className={classes.halfPhoto}
        />
      </Grid>
    </Grid>
  );

  return (
    <Grid ref={ref} container className={classes.wrapper}>
      {inView ? renderer : null}
    </Grid>
  );
};

export default PhotoCollage3;
